import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {BrandMapPinIcon} from "@pg-design/icons-module";
import {Image} from "@pg-design/image-module";

import {SeoMainHeadline} from "../../../atoms/SeoMainHeadline";
import {OfferType} from "../../../offer/types/OfferType";
import {getThumbnailLink} from "../../../utils/get_thumbnail_link";
import {IVendorDetail} from "../../types/IVendorDetail";
import {generateVendorHeadline} from "../../utils/generate_vendor_headline";

interface IProps {
    vendor: IVendorDetail;
    onShowMapClick?: () => void;
    hasActiveOffers?: boolean;
    selectedRegionName?: string | null;
    selectedOfferType?: OfferType | null;
}

export const VendorDetailHeader = (props: IProps) => {
    const {vendor, onShowMapClick, hasActiveOffers = false, selectedRegionName, selectedOfferType} = props;

    const headline = generateVendorHeadline(vendor.name, selectedRegionName, selectedOfferType);

    return (
        <div className={vendorDetailHeaderBase}>
            <div className={vendorInfoWrapper}>
                <Image alt={`${vendor.name} logo`} src={getThumbnailLink(vendor.logo_url, 120, 90) ?? ""} width="120" height="90" className={logoStyles} />

                <div className={vendorTextWrapper}>
                    <div className={vendorNameWrapper}>
                        <SeoMainHeadline as="h1" variant="headline_2" className={vendorNameStyle}>
                            {headline}
                        </SeoMainHeadline>
                    </div>
                </div>
            </div>

            {hasActiveOffers && onShowMapClick && (
                <Button className={mapButtonStyle} iconLeft={BrandMapPinIcon} variant="brand_icon" size="big" onClick={onShowMapClick}>
                    Zobacz na mapie
                </Button>
            )}
        </div>
    );
};

const vendorDetailHeaderBase = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: 3,

    md: {
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center"
    }
});

const vendorInfoWrapper = css({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    flex: 1
});

const vendorTextWrapper = css({
    display: "flex",
    flexDirection: "column"
});

const vendorNameWrapper = css({
    display: "flex",
    flexDirection: "column",
    gap: 0.5,

    md: {
        flexDirection: "row",
        alignItems: "baseline",
        gap: 2
    }
});

const logoStyles = css({
    flex: "0 0 auto",
    alignSelf: "center",
    mr: 2,
    height: "6rem",

    "& > img": {
        width: "auto",
        height: "100%"
    },

    md: {
        height: "10rem"
    }
});

const vendorNameStyle = css({
    pt: 0.5,
    pb: 0.5,

    md: {
        pt: 1,
        pb: 0
    }
});

const mapButtonStyle = css({
    alignSelf: "flex-start",
    flex: "0 0 auto",
    pl: 0,
    md: {
        alignSelf: "flex-end"
    }
});
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {BrandMapPinIcon} from "@pg-design/icons-module";
import {Image} from "@pg-design/image-module";

import {SeoMainHeadline} from "../../../atoms/SeoMainHeadline";
import {OfferType} from "../../../offer/types/OfferType";
import {getThumbnailLink} from "../../../utils/get_thumbnail_link";
import {IVendorDetail} from "../../types/IVendorDetail";
import {generateVendorHeadline} from "../../utils/generate_vendor_headline";

interface IProps {
    vendor: IVendorDetail;
    onShowMapClick?: () => void;
    hasActiveOffers?: boolean;
    selectedRegionName?: string | null;
    selectedOfferType?: OfferType | null;
}

export const VendorDetailHeader = (props: IProps) => {
    const {vendor, onShowMapClick, hasActiveOffers = false, selectedRegionName, selectedOfferType} = props;

    const headline = generateVendorHeadline(vendor.name, selectedRegionName, selectedOfferType);

    return (
        <div className={vendorDetailHeaderBase}>
            <div className={vendorInfoWrapper}>
                <Image alt={`${vendor.name} logo`} src={getThumbnailLink(vendor.logo_url, 120, 90) ?? ""} width="120" height="90" className={logoStyles} />

                <div className={vendorTextWrapper}>
                    <div className={vendorNameWrapper}>
                        <SeoMainHeadline as="h1" variant="headline_2" className={vendorNameStyle}>
                            {headline}
                        </SeoMainHeadline>
                    </div>
                </div>
            </div>

            {hasActiveOffers && onShowMapClick && (
                <Button className={mapButtonStyle} iconLeft={BrandMapPinIcon} variant="brand_icon" size="big" onClick={onShowMapClick}>
                    Zobacz na mapie
                </Button>
            )}
        </div>
    );
};

const vendorDetailHeaderBase = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: 3,

    md: {
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center"
    }
});

const vendorInfoWrapper = css({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    flex: 1
});

const vendorTextWrapper = css({
    display: "flex",
    flexDirection: "column"
});

const vendorNameWrapper = css({
    display: "flex",
    flexDirection: "column",
    gap: 0.5,

    md: {
        flexDirection: "row",
        alignItems: "baseline",
        gap: 2
    }
});

const logoStyles = css({
    flex: "0 0 auto",
    alignSelf: "center",
    mr: 2,
    height: "6rem",

    "& > img": {
        width: "auto",
        height: "100%"
    },

    md: {
        height: "10rem"
    }
});

const vendorNameStyle = css({
    pt: 0.5,
    pb: 0.5,

    md: {
        pt: 1,
        pb: 0
    }
});

const mapButtonStyle = css({
    alignSelf: "flex-start",
    flex: "0 0 auto",
    pl: 0,
    md: {
        alignSelf: "flex-end"
    }
});
